import React from 'react'
import './occupyMarsTopBar.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFacebook, faInstagram, faTwitter, faYoutube, faTwitch, faSteam, faReddit, faDiscord } from '@fortawesome/free-brands-svg-icons'

const OccupyMarsTopBar = () => {

    return(
        <div id='top-nav-bar'>
            <a href='https://occupymarsgame.com/'>Occupy Mars</a>
            <a className='selected'>Roadmap</a>
            <a href='https://bugtracker.occupymarsgame.com/'>Bugtracker</a>
            <a href="https://occupymars.fandom.com/">Wiki ↗</a>
            <a href="https://www.kickstarter.com/projects/playway/occupy-mars-the-game/">Kickstarter ↗</a>
            <a href="https://tiltloot.com/collections/pyramid-games/" target="_blank">Merch ↗</a>
	    <div id='top-nav-bar-social'>
                <a href='https://www.facebook.com/PyramidGamesLab/' target='_blank' rel='noreferrer'><FontAwesomeIcon icon={faFacebook}/></a>
                <a href='https://www.instagram.com/pyramid.games/' target='_blank' rel='noreferrer'><FontAwesomeIcon icon={faInstagram}/></a>
                <a href='https://twitter.com/pyramidlab' target='_blank' rel='noreferrer' className="stylicon"></a>  
                <a href='https://www.youtube.com/user/ThePyramidLab' target='_blank' rel='noreferrer'><FontAwesomeIcon icon={faYoutube}/></a>
                <a href='https://www.twitch.tv/pyramid_games' target='_blank' rel='noreferrer'><FontAwesomeIcon icon={faTwitch}/></a>
                <a href='https://www.reddit.com/r/occupymarsgame/' target='_blank' rel='noreferrer'><FontAwesomeIcon icon={faReddit}/></a>
                <a href='https://store.steampowered.com/developer/pyramidgames' target='_blank' rel='noreferrer'><FontAwesomeIcon icon={faSteam}/></a>
                <a href='https://discord.gg/sv9UWeh' target='_blank' rel='noreferrer'><FontAwesomeIcon icon={faDiscord}/></a>
            </div>
        </div>
    )
} 

export default OccupyMarsTopBar
